<script setup lang="ts">
import ButtonClose from '@/components/button/ButtonClose.vue'
import {
    messageRegister,
    messageRegisterEmpty,
    showMessageRegister
} from '@/event/account/alert/messageRegister'

function toggleAlertRegisterHappy() {
    showMessageRegister.value = false
    setTimeout(() => {
        messageRegister.value = messageRegisterEmpty
    }, 300)
}
</script>

<template>
    <section class="section-message-alert-register-happy">
        <div
            class="div-overlay-register-alert-happy"
            @click="toggleAlertRegisterHappy"
        ></div>

        <Transition
            name="transition-message-register"
            enter-active-class="transition-all duration-300 ease-in-out"
            leave-active-class="transition-all duration-300 ease-in-out "
            enter-from-class="opacity-0 -translate-y-full"
            enter-to-class="opacity-100 translate-y-0"
            leave-from-class="opacity-100 translate-y-0"
            leave-to-class="opacity-0 -translate-y-full"
            :key="'MessageRegister'"
        >
            <div
                v-if="
                    messageRegister.errors &&
                    messageRegister.errors.length > 0 &&
                    showMessageRegister
                "
                :class="messageRegister.class ? messageRegister.class : 'hidden'"
                class=""
            >
                <div :class="`div-header-alert-register-happy-${messageRegister.class}`">
                    <ButtonClose
                        :function="toggleAlertRegisterHappy"
                        :hover-color="
                            messageRegister.class === 'success'
                                ? 'success-happy'
                                : 'error-happy'
                        "
                    />
                </div>
                <div class="div-content-alert-errors-register-happy">
                    <p class="p-errors-register-happy">{{ messageRegister.message }}</p>
                    <ul
                        v-for="(error, index) in messageRegister.errors"
                        :key="index"
                        class="bullet-happy"
                    >
                        <li class="font-medium text-base">{{ error }}</li>
                    </ul>
                </div>
            </div>
            <div
                v-else-if="
                    messageRegister.message &&
                    showMessageRegister &&
                    (!messageRegister.errors || messageRegister.errors.length === 0)
                "
                :class="messageRegister.class ? messageRegister.class : 'hidden'"
            >
                <div :class="`div-header-alert-register-happy-${messageRegister.class}`">
                    <ButtonClose
                        :function="toggleAlertRegisterHappy"
                        :hover-color="
                            messageRegister.class === 'success'
                                ? 'success-happy'
                                : 'error-happy'
                        "
                    />
                </div>
                <div class="div-content-alert-register-happy">
                    <p class="text-center font-semibold">
                        {{ messageRegister.message }}
                    </p>
                </div>
            </div>
        </Transition>
    </section>
</template>

<style scoped>
.section-message-alert-register-happy {
    @apply fixed flex justify-center w-full h-full z-20 font-medium;
}

.div-overlay-register-alert-happy {
    @apply w-full h-full;
}

.error {
    @apply absolute z-10 bg-border-red-happy-light rounded-md pb-2 flex flex-col items-center justify-center gap-2 min-w-[19rem] max-w-[19rem] max-h-fit mt-48 text-bg-happy-light;
}

.success {
    @apply absolute z-10 bg-green-happy rounded-md pb-2 flex flex-col items-center justify-center gap-2 min-w-[19rem] max-w-[19rem] max-h-fit mt-48 text-text-dark-happy-light;
}

.div-header-alert-register-happy-error {
    @apply flex flex-col items-end bg-header-red-happy w-full rounded-t-md px-3 py-2;
}

.div-header-alert-register-happy-success {
    @apply flex flex-col items-end bg-green-light-happy w-full rounded-t-md px-3 py-2;
}

.div-content-alert-register-happy {
    @apply px-3 py-2;
}

.div-content-alert-errors-register-happy {
    @apply px-3 py-2;
}

.p-errors-register-happy {
    @apply font-bold;
}

.bullet-happy {
    @apply relative pl-6 list-disc;
}
</style>
